import React from 'react'
import BottleImg from '../../assets/SinoclearBottle.png'
const Hero = () => {
    return (
        <section className="bg-landing-bg bg-cover bg-center relative p-3">
            <div className=" max-w-7xl mx-auto px-4 flex items-center min-h-[8vh]  ">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <h1 className="text-white md:text-5xl text-2xl font-bold leading-tight mb-6">
                            Breathe Freely, Live Fully with Sinoclear
                        </h1>
                        <p className="text-gray-300 text-xl mb-8">
                            Unlock the secret to clear sinuses and lasting relief from congestion.

                        </p>
                        <a
                            href="#pricing"
                            className="bg-blue-100 text-navy-900 px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:-translate-y-1 duration-150 ease-in-out"
                        >
                            Order Now
                        </a>
                    </div>
                    <div className="relative">
                        <img
                            src={BottleImg}
                            alt="Sinoclear Product"
                            className="object-contain hover:opacity-85 duration-150 ease-in-out"

                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero
